import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Page from 'component/Page';
import Table from 'component/Table';
import sendRequest from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import { getParams } from 'util/utils';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';

const ServerLogs = ({ data = { fileName: null } }) => {
    const params = getParams();
    const currentUser = useSelector(selectCurrentUser);
    const fileName = data.fileName || params?.fileName;
    const [ selectedUser, setSelectedUser ] = useState(fileName);
    const [ dataLogs, setDataLogs ] = useState([]);

    const fetchLogs = useCallback(async () => {
        try {
            const response = await sendRequest({
                url: `${Urls.serverlogs.getfilename}/${selectedUser}`,
            });
            const { result } = response;
            const resultArray = result.split('\n').map((item) => {
                try {
                    return JSON.parse(item);
                } catch (parseError) {
                    return null;
                }
            });
            const validLogs = resultArray.filter((log) => log !== null);
            setDataLogs(validLogs);
        } catch (error) {
            console.error('Error fetching logs:', error);
        }
    }, [ selectedUser, setDataLogs ]);

    useEffect(() => {
        fetchLogs();
    }, [ fetchLogs ]);

    const dataTable = useMemo(() =>
        dataLogs.map((dataLog) => ({
            data: [
                dataLog.level,
                dataLog.message,
                dataLog.timestamp,
            ],
        })),
        [ dataLogs ]
    );

    return (
        <Page
            title={string.APP_SUMMARY_PAGE_TITLE}
            body={
                <Table
                    className="nowrap"
                    headers={[ 'level', 'message', 'timestamp' ]}
                    data={dataTable}
                    isPaging={false}
                />
            }
        />
    );
};

export default ServerLogs;
